import { types } from 'mobx-state-tree'

import buildCustomValidationStore from '~/stores/models/customValidation'

import USER_VALIDATIONS from '~/utilities/userValidations'

const AddressModelBase = types
  .model('AddressModel', {
    address: types.maybe(types.string),
    city: types.maybe(types.string),
    countryState: types.maybe(types.string),
    zipcode: types.maybe(types.string)
  })
  .views(self => ({
    get isAddressValid() {
      return (
        !self.validateKey('address') &&
        !self.validateKey('city') &&
        !self.validateKey('countryState') &&
        !self.validateKey('zipcode')
      )
    }
  }))
  .actions(self => ({
    validateFields() {
      const KEYS_TO_VALIDATE = ['address', 'city', 'countryState', 'zipcode']
      self.validateKeyList(KEYS_TO_VALIDATE)
    },
  }))

const CustomValidation = buildCustomValidationStore({
  validationObject: USER_VALIDATIONS
})

const AddressModel = types.compose(
  AddressModelBase,
  CustomValidation
)

export default AddressModel
